import { useQuery } from '@tanstack/react-query';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useVacationTypesQuery = () =>
  useQuery({
    queryKey: queryKeys.schedule.vacationTypes(),
    queryFn: () =>
      ScheduleConfigService.scheduleConfigServiceGetVacationTypes(),
  });
